export default __webpack_public_path__ + "static/media/vjcscancode.0d2aa63c.jpg";